import { INSTANCE as NativeDownloadManager } from '@nativeAPP/nativeDownload/NativeDownloadManager'
import { INSTANCE as DeviceManager } from '@core/devices/DeviceManager'
import { AbsDownloadTask } from '@/core/transmission/AbsDownloadTask'
import type { FileInfo } from './IReadOnlyFileTransmissionManager'
import { isInIosAPP, transmissionTaskPool } from '../Utils'
import type { SpecificTaskInfo } from './ITask'
import { TaskError } from './ITask'
import {
  LAN_DOWNLOAD_MAX_SIZE_SINGLE_FILE_IN_BYTES,
  LAN_DOWNLOAD_MAX_SIZE_SINGLE_FILE_IN_BYTES_RANGE,
} from '../FileUtils'

export class DownloadTaskDirectly extends AbsDownloadTask {
  #isSupportRange?: boolean
  #isStreamDownload = false
  constructor(
    deviceId: string,
    fileInfo: FileInfo,
    appId: string,
    mirrorTask?: SpecificTaskInfo,
    isSupportRange?: boolean
  ) {
    super(deviceId, fileInfo, true, appId, mirrorTask)
    this.#isSupportRange = isSupportRange
  }

  async start(): Promise<void> {
    transmissionTaskPool.addTask(async () => {
      try {
        const device = this._getDevice()

        if (!device) {
          this._terminateDueToDeviceNotFound()

          return
        }
        const downloadUrl = await this.getDownloadUrl()

        if (!downloadUrl) {
          console.log(`[Transmission]: getDownloadUrl failed ${this._fileName} ${new Date().toLocaleString()}`)
          this._failedReason = TaskError.GET_DEVICE_DOWNLOAD_URL_FAILED
          this._taskScheduler?.setTaskError(this)

          return
        }

        this._downloadUrl = downloadUrl
        this.setTimer()
        const downloadThreshold = this.#isSupportRange
          ? LAN_DOWNLOAD_MAX_SIZE_SINGLE_FILE_IN_BYTES_RANGE
          : LAN_DOWNLOAD_MAX_SIZE_SINGLE_FILE_IN_BYTES

        if (this._fileSize >= downloadThreshold) {
          console.log(
            `[Transmission]: Direct Download ${this._fileName} by a link  ${
              this._fileName
            } ${new Date().toLocaleString()}`
          )
          this.#isStreamDownload = false
          this.onCompleted(downloadUrl, false)
        } else {
          console.log(
            `[Transmission]: Download ${this._fileName} by http request  ${
              this._fileName
            } ${new Date().toLocaleString()}`
          )
          this.#isStreamDownload = true

          this._onDeviceSideExecuteCompleted(downloadUrl, true, this.#isSupportRange)
        }
      } catch (error) {
        this._failedReason = TaskError.GET_DEVICE_DOWNLOAD_URL_FAILED

        this._handleError(error)
      }
    })
  }

  async pause(): Promise<void> {
    //do nothing
  }

  async resume(): Promise<void> {
    // 每次重开需要新走流程，局域网端侧链接有时效性
    this.start()
  }

  async onRemove(): Promise<boolean> {
    this.markAsDeleted()
    this._requestCancelToken?.cancel()
    this._requestCancelToken = undefined
    this._deleteZipFile(this.#isStreamDownload)

    if (isInIosAPP()) {
      NativeDownloadManager.deleteTask(this.id)
    }

    return true
  }

  async getDownloadUrl(): Promise<string | undefined> {
    const device = DeviceManager.getDeviceById(this._deviceId)

    if (!device) return undefined

    return await device.getDownloadUrl(this._parentPath + this._fileName, false, true)
  }
}
